const topicItems = [
  { label: '完结漫画大全', hot: true, count: '2.3w+' },
  { label: '漫画全集', hot: true, count: '1.8w+' },
  { label: '下拉式漫画', hot: false, count: '1.5w+' },
  { label: '免费漫画推荐', hot: true, count: '1.2w+' },
  { label: '完结日漫', hot: false, count: '9800+' },
  { label: '完结国漫', hot: true, count: '8600+' },
  { label: '漫画完整版', hot: false, count: '7200+' },
  { label: '滚动漫画阅读', hot: false, count: '6500+' },
  { label: '全集漫画在线', hot: true, count: '5900+' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            大家都在关注的完结漫画话题，看看有没有你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicItems.map((item, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100/80 text-primary-700 hover:bg-primary-200/80'
                  : 'bg-background-100 border border-background-200/70 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {item.label}
              <span className={`text-xs font-normal ${item.hot ? 'text-primary-500' : 'text-foreground-500'}`}>
                {item.count}
              </span>
              {item.hot && (
                <i className="ri-fire-line text-xs text-accent-500"></i>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}